// Libraries
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: IconCalendar
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconCalendar = () => {
	return (
		<Figure xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 56 57">
			<path
				fill="#7c838a"
				d="M31.5 34.5h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-5 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-5 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm15-4h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-5 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-10 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm5 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm10-4h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-5 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-5 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm2-12a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1zm7 0a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1zm-14 0a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1zm18 24a2 2 0 0 1-2 2h-19a2 2 0 0 1-2-2v-14h23zm-2-22v2a2 2 0 0 1-4 0v-2h-3v2a2 2 0 0 1-4 0v-2h-3v2a2 2 0 0 1-4 0v-2h-1a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h19a4 4 0 0 0 4-4v-18a4 4 0 0 0-4-4z"
			/>
		</Figure>
	);
};

const Figure = styled.svg`
	display: flex;
	flex-direction: row;
	width: ${rem('56px')};
	height: ${rem('56px')};
`;

export default IconCalendar;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-calendar.jsx